import request from "@/utils/request";

// 专家参与项目列表
export function general(data) {
  return request({
    url: "/smartfox2/index",
    method: "post",
    data,
  });
}

//退出登录
export function logout(data) {
  return request({
    url: "/smartfox2/index",
    method: "post",
    data,
  });
}
